<template>
    <div>
        <div class="inner-header">
            <nav class="navbar fixed-top animate__animated animate__slideInRight">
                <a @click="$router.go(-1)" class="back-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                        <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                            <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none"
                                stroke="#000" stroke-width="2" />
                            <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                                transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                        </g>
                    </svg>
                </a>
                <a href="javascript:void(0);" class="center-header">Manage Campaigns</a>
            </nav>
        </div>
        <div class="inner-page animate__animated animate__slideInRight">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="search-holder mt-30 search-holder-list">
                            <div class="input-group">
                                <input type="text" placeholder="Search by broker name or firm name"
                                  @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control"
                                  @keyup.enter="FilterData" />
                                  <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001"
                                    style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14"
                                    class="close r-70">
                                    <g>
                                      <g>
                                        <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                                        L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                                        c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                                        l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                                        L284.286,256.002z" />
                                      </g>
                                    </g>
                                  </svg>
                                <div class="input-group-append align-fix" id="button-addon4">
                                      <button class="btn btn-search" :disabled="!Filter" @click="FilterData" type="button">
                                          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451"
                                            style="enable-background: new 0 0 451 451" xml:space="preserve">
                                            <g>
                                              <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                                    s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                                    C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                                    s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                                            </g>
                                          </svg>
                                     </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-holder">
                        <b-tabs content-class="mt-3" justified>
                            <b-tab 
                                  v-for="(tab, index) in tabs"
                                  :key="index"
                                  :title="tab.title"
                                  @click="GetCampaign(tab.label)"
                            >
                                <div class="col-12">
                                    <div class="card enquiry-card campaign-card">
                                        <b-list-group class="list-group-flush">
                                            <b-list-group-item  v-for ="(item, index) in GetAllCampaigns" :key="index">
                                              <router-link :to="{ name: 'CampaignDetails', params: {  id: item.id }}">
                                                <div class="row">
                                                    <div class="col-7 pr-1">
                                                        <span class="name ellipses">{{item.firm_name}}</span>
                                                    </div>
                                                    <div class="col-5 pl-1 text-right">
                                                        <span class="project-name ellipses">{{item.campaign_type}}</span>
                                                        <span class="project-name ellipses" >{{item.executed}}</span>
                                                    </div>
                                                </div>
                                              </router-link>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
                <router-link :to="{ name: 'AddNewCampaigninMeetings', params: { id: $route.params.id }}" class="float-btn"><img src="@/assets/plus.svg" alt=""></router-link>
            </div>
        </div>
    </div>
</template>
<script>
import { paramsFromQuery } from "@/assets/scripts/utility.js";
export default {
  name: "ManageCampaign",
  data() {
    return {
      tabs: [
        { label: "active", title: "Active" },
        { label: "upcoming", title: "Up Coming" },
        { label: "past", title: "Past" },
      ],
      GetAllCampaigns: [],
      Filter: this.$route.query.search_query,
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters.sDefaults;
    }
  },
  created() {
    let defT = this.activeTab;
    let defTObj = this.tabs.find((k) => k.label === defT.tab);
    this.GetCampaign(defTObj.label);
  },
  watch: {
    $route(to, from) {
      this.GetCampaign();
    },
  },
  methods: {
    GetCampaign(row) {
      let queryP = {};
      queryP['campaign_status'] = row;
      if (queryP.campaign_status === undefined) {
        queryP.campaign_status = 'active'
      }
      paramsFromQuery(queryP, this.$route.query);
        let url = `users/meetings/${this.$route.params.id}/meeting_campaign_list`;
        this.$axios
          .get(url, { params: queryP })
          .then((res) => {
            this.GetAllCampaigns = res.data.campaign_data
            this.GetAllCampaigns.forEach((item,index) => {
            if (item.executed === true) {
                item.executed = 'Executed'
              } else {
                item.executed = 'Not-Executed'
              }
            });
          })
          .catch((err) => console.log(err));
    },
    resetFilter() {
      let rQ = this.$route.query;
      this.Filter = "";
      if (rQ.search_query) {
        let {
          search_query,
          ...newQ
        } = rQ;
        this.$router.replace({
          query: newQ
        });
      }
    },
    FilterData() {
        if (this.Filter) {
          let newQ = {
            ...this.$route.query,
            search_query: this.Filter
          };
          this.$router.replace({
            query: newQ
          });
        }
    }
  }
}
</script>
<style lang="scss" scoped>


</style>